import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import LeftHandSideMenu from "../left-handside-menu/LeftHandSideMenu";
// import PracticeDashboard from "../practice-dashboard/PracticeDashboard";
import Reviews from "../reviews/Reviews";
import "./profileInformation.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import MainPractice from "../main-practice/MainPractice";
import ProvidersDetails from "../providers/ProvidersDetails";
import Manageusers from "../manageusers/Manageusers";
import { fetchPracticeInfoDetails } from "../../../store/PracticeInfo/PracticeInfoActions";
import { fetchMyPractices } from "../../../store/MyPractice/MyPracticeActions";
import DashboardWrapper from "../../dashboard/DashboardWrapper";
import PracticeStatus from "./PracticeStatus";
import { MyAccountContext } from "../../../App";
import PopupModal from "../../../common/PopupModal";
import { fetchPracticeStatus } from "../../../store/Status/PracticeStatusActions";

const PracticeProfileInformation = () => {
  const [selectedTab, setSelectedTab] = useState("info");
  const [isTab, setIsTab] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPractice, setSelectedPractice] = useState(null);

  const { practiceInfoDetails } = useSelector(
    (state) => state?.practiceInfoDetails
  );

  const myPracticeState = useSelector((state) => state.myPractice);
  const practices = myPracticeState?.data?.data?.userPracticeResponseDTO || [];

  const { grantedRoles, user } = useContext(MyAccountContext);

  const location = useLocation();
  const currentPath = location.pathname;
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPracticeInfoDetails(practiceId));
  }, [dispatch, practiceId]);

  useEffect(() =>{
    dispatch(fetchPracticeStatus(practiceId));
  },[dispatch, practiceId]);

  useEffect(() => {
    setSelectedTab(locationHeaderData[4]);
  }, [locationHeaderData[4]]);

  useEffect(() => {
    if (user?.displayId && grantedRoles?.includes("ROLE_PRACTICE")) {
      dispatch(fetchMyPractices(user.displayId));
    }
  }, [dispatch, user?.displayId, grantedRoles]);

  useEffect(() => {
    if (
      currentPath === `/practice/${practiceId}/profile-information/dashboard` ||
      currentPath === `/practice/${practiceId}/profile-information/provider` ||
      currentPath === `/practice/${practiceId}/profile-information/reviews` ||
      currentPath === `/practice/${practiceId}/profile-information/manageusers`
    ) {
      setIsTab(false);
    } else if (currentPath === `/practice/${practiceId}/profile-information`) {
      setSelectedTab("info");
    } else {
      setIsTab(true);
    }
  }, [currentPath, practiceId]);

  const formatAddress = (streetAddress) => {
    if (!streetAddress) return "";

    const { street1, city, state, postalCode } = streetAddress;
    let address = street1 || "";
    if (city) address += address ? `, ${city}` : city;
    if (state) address += address ? `, ${state}` : state;
    if (postalCode) address += address ? ` ${postalCode}` : postalCode;

    return address;
  };

  const handleChangeClick = (e) => {
    e.preventDefault();
    if (grantedRoles?.includes("ROLE_PRACTICE")) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPractice(null);
  };

  const handlePracticeSelect = (practice) => {
    setSelectedPractice(practice);
    setIsModalOpen(false);
  };

  const renderModalContent = () => {
    if (!isModalOpen) return null;

    return (
      <div>
        <div>
          {practices.length > 0 ? (
            practices.map((practice) => (
              <Link
                key={practice.practiceDisplayId}
                className="practice-item"
                onClick={() => handlePracticeSelect(practice)}
                to={`/practice/${practice.practiceDisplayId}/profile-information/dashboard`}
              >
                <a className="practice-name">{practice.name}</a>
                {practice.streetAddress && (
                  <div className="practice-address">
                    {formatAddress(practice.streetAddress)}
                  </div>
                )}
              </Link>
            ))
          ) : (
            <div className="practice-item">No practices available</div>
          )}
        </div>
      </div>
    );
  };

  const displayPracticeName =
    selectedPractice?.name || practiceInfoDetails?.name || "Select Practice";
  // const displayAddress = selectedPractice?.streetAddress
  //   ? formatAddress(selectedPractice.streetAddress)
  //   : practiceInfoDetails?.streetAddress
  //   ? formatAddress(practiceInfoDetails.streetAddress)
  //   : "";

  return (
    <div className="profileinformation">
      <div className="container-fluid main-container main-wrapper">
        {/* SIDE BAR SECTION START */}
        <div className="sidebar-container sidebar-container-provider">
          <div id="practice-sidebar" className="sidebar">
            <div className="sidebar-section welcome-section">
              <div className="sidebar-header">
                <h2 className="sidebar-header-text">
                  <span>Welcome</span>
                </h2>
              </div>

              <div className="select-practice">
                <p className="practice-name">{displayPracticeName}</p>
                {grantedRoles?.includes("ROLE_PRACTICE") && (
                  // <a
                  //   href="#"
                  //   className="change-link"
                  //   onClick={isModalOpen ? handleCloseModal : handleChangeClick}
                  // >
                  //   {isModalOpen ? "Cancel" : "Change"}
                  // </a>
                  // </a>
                  <div
                    className="change-link"
                    onClick={isModalOpen ? handleCloseModal : handleChangeClick}
                  >
                    {isModalOpen ? "Cancel" : "Change"}
                  </div>
                )}
              </div>
            </div>

            <LeftHandSideMenu />
          </div>
        </div>
        <div id="provider-main" className="flush-padding col-md-9">
          {isTab && (
            <div className="main-info main-info-profile">
              <span className="status-section pull-right">
                <span>
                  <PracticeStatus />
                </span>
                {/* <span>Status: ON</span> */}
              </span>
              <h2 className="info-section-header text-uppercase">
                {displayPracticeName}
              </h2>
              <nav>
                <ul id="practice-profile-tabs" className="list-inline">
                  <li
                    className={`${selectedTab === "info" && "selected"}`}
                    onClick={() => {
                      setSelectedTab("info");
                    }}
                  >
                    <NavLink
                      to={`/practice/${practiceId}/profile-information/info`}
                    >
                      Practice Info
                    </NavLink>
                  </li>
                  <li
                    className={`${selectedTab === "photos" && "selected"}`}
                    onClick={() => {
                      setSelectedTab("photos");
                    }}
                  >
                    <NavLink
                      to={`/practice/${practiceId}/profile-information/photos`}
                    >
                      Photos
                    </NavLink>
                  </li>
                  <li
                    className={`${selectedTab === "highlights" && "selected"}`}
                    onClick={() => {
                      setSelectedTab("highlights");
                    }}
                  >
                    <NavLink
                      to={`/practice/${practiceId}/profile-information/highlights`}
                    >
                      Practice Highlights
                    </NavLink>
                  </li>
                  <li
                    className={`${selectedTab === "officeHours" && "selected"}`}
                    onClick={() => {
                      setSelectedTab("officeHours");
                    }}
                  >
                    <NavLink
                      to={`/practice/${practiceId}/profile-information/officeHours`}
                    >
                      Office Hours
                    </NavLink>
                  </li>
                  {!grantedRoles?.includes("ROLE_PRACTICE") && (
                    <li
                      className={`${
                        selectedTab === "fee-schedules" && "selected"
                      }`}
                      onClick={() => {
                        setSelectedTab("fee-schedules");
                      }}
                    >
                      <NavLink
                        to={`/practice/${practiceId}/profile-information/fee-schedules`}
                      >
                        Fee Schedules
                      </NavLink>
                    </li>
                  )}
                  <li
                    className={`${selectedTab === "services" && "selected"}`}
                    onClick={() => {
                      setSelectedTab("services");
                    }}
                  >
                    <NavLink
                      to={`/practice/${practiceId}/profile-information/services`}
                    >
                      Services
                    </NavLink>
                  </li>
                </ul>
              </nav>
              <Outlet />
            </div>
          )}

          {!isTab &&
            currentPath ===
              `/practice/${practiceId}/profile-information/dashboard` && (
              <div className="main-info main-info-profile">
                <DashboardWrapper />
              </div>
            )}
          {!isTab &&
            currentPath ===
              `/practice/${practiceId}/profile-information/provider` && (
              <div className="main-info main-info-profile">
                <ProvidersDetails />
              </div>
            )}
          {!isTab &&
            currentPath ===
              `/practice/${practiceId}/profile-information/reviews` && (
              <div className="main-info main-info-profile">
                <Reviews />
              </div>
            )}
          {!isTab &&
            currentPath ===
              `/practice/${practiceId}/profile-information/manageusers` && (
              <div className="main-info main-info-profile">
                <Manageusers />
              </div>
            )}
        </div>
        {isModalOpen && grantedRoles?.includes("ROLE_PRACTICE") && (
          <PopupModal
            isOpen={true}
            onClose={handleCloseModal}
            popupHeading="Select a Practice"
            customRender={renderModalContent}
            popupType="center"
            width="30%"
          />
        )}
      </div>
    </div>
  );
};
export default PracticeProfileInformation;
